import logo from "../Assets/Logo.png"
import Code from "../Assets/Coding.png"
import Instagram from "../Assets/instagram.png"
import Twitter from "../Assets/twitter.png"
import Github from "../Assets/github.png"
import Web from "../Assets/web-developer.png"
import Graphic from "../Assets/graphic-designer.png"
import Ux from "../Assets/uxui.png"
import Restuarent from "../Assets/Restuarent.jpeg"
import Portfolio from "../Assets/portfolio.jpeg"
import Chawla from "../Assets/Chawla.jpeg"
import Touch from "../Assets/touch.png"
import Top from "../Assets/top.png"
import Phone from "../Assets/phone.png"
import Email from "../Assets/email.png"
import Address from "../Assets/address.png"
import Game from "../Assets/game.png"
import About from "../Assets/about.png"
import Laptop from "../Assets/laptop.png"
import Happy from "../Assets/happy.png"
import People from "../Assets/people.png"
import Experience from "../Assets/experience.png"
import Resume from "../Assets/Resume.pdf"

export default {
    logo,
    Code,
    Instagram,
    Twitter,
    Github,
    Web,
    Graphic,
    Ux,
    Restuarent,
    Portfolio,
    Chawla,
    Touch,
    Top,
    Phone,
    Email,
    Address,
    Game,
    About,
    Laptop,
    Happy,
    People,
    Experience,
    Resume,
}